const marketingAr = {
  "nav.campaigns": "الحملات",
  "nav.automations": "الأتمتة",
  "nav.feeds": "خلاصات المنتجات",
  "nav.seo": "تحسين محركات البحث",
  "palette.action.campaign": "إنشاء حملة بريدية",

  // abandoned checkouts: reminders
  "ab.col.reminders": "التذكيرات",
  "ab.reminders_sent": "أُرسل: {n}",
  "ab.no_reminders": "لا يوجد",
  "ab.clicked": "نُقر",
  "ab.clicked_on": "نُقر في {when}",
  "ab.reminder_settings": "إعدادات التذكير",
  "ab.send_reminder": "إرسال رسالة تذكير",
  "ab.reminder_sent": "أُرسل التذكير",
  "ab.reminder_status": "التذكيرات المرسلة: {n}، آخرها في {when}",
  "ab.whatsapp": "إرسال عبر واتساب",
  "ab.whatsapp_text": "مرحباً {name}، تركت بعض المنتجات في سلتك. يمكنك إكمال طلبك من هنا: {url}",

  // marketing overview
  "mkt.description": "اعرف ما تحققه حملاتك وأتمتتك وقنواتك.",
  "mkt.overview": "نظرة عامة",
  "mkt.campaigns": "الحملات",
  "mkt.automations": "الأتمتة",
  "mkt.feeds": "خلاصات المنتجات",
  "mkt.kpi.sessions": "الجلسات",
  "mkt.kpi.orders": "الطلبات",
  "mkt.kpi.sales": "المبيعات",
  "mkt.kpi.conversion": "معدل التحويل",
  "mkt.email_results": "التسويق عبر البريد",
  "mkt.recovery_results": "استرداد عمليات الدفع المتروكة",
  "mkt.rec.abandoned": "عمليات دفع متروكة",
  "mkt.rec.reminded": "تم تذكيرهم",
  "mkt.rec.recovered": "مستردة",
  "mkt.rec.sales": "مبيعات مستردة",
  "mkt.see_automations": "عرض الأتمتة",
  "mkt.channels": "القنوات والحملات",
  "mkt.channels_hint": "الجلسات والطلبات والمبيعات حسب مصدر الزوار (وسوم UTM والمواقع المحيلة).",
  "mkt.col.source": "المصدر / الوسيط",
  "mkt.col.campaign": "الحملة",
  "mkt.quota": "رسائل التسويق هذا الشهر",
  "mkt.utm.title": "منشئ روابط الحملات",
  "mkt.utm.hint": "ضع وسوماً على الروابط التي تنشرها في وسائل التواصل والإعلانات ومع المؤثرين لتظهر مبيعاتها هنا.",
  "mkt.utm.page": "الصفحة",
  "mkt.utm.page_hint": "مسار في المتجر مثل ‎/collections/sale أو رابط كامل.",
  "mkt.utm.source": "المصدر",
  "mkt.utm.medium": "الوسيط",
  "mkt.utm.campaign": "اسم الحملة",
  "mkt.utm.content": "المحتوى",
  "mkt.utm.term": "الكلمة",
  "mkt.utm.result": "رابط الحملة",

  // campaigns
  "mkt.new_campaign": "إنشاء حملة",
  "mkt.no_campaigns": "أرسل أول حملة بريدية",
  "mkt.no_campaigns_body": "أعلن عن منتجاتك الجديدة وعروضك للعملاء الذين وافقوا على تلقي رسائلك. سترى الفتح والنقرات والمبيعات التي تحققها كل حملة.",
  "mkt.col.status": "الحالة",
  "mkt.col.sent": "المرسلة",
  "mkt.col.open_rate": "معدل الفتح",
  "mkt.col.click_rate": "معدل النقر",
  "mkt.col.sales": "المبيعات",
  "mkt.status.draft": "مسودة",
  "mkt.status.scheduled": "مجدولة",
  "mkt.status.sending": "قيد الإرسال",
  "mkt.status.sent": "أُرسلت",
  "mkt.status.cancelled": "أُوقفت",
  "mkt.scheduled_for": "مجدولة في {when}",
  "mkt.sent_on": "أُرسلت في {when}",
  "mkt.edited": "عُدلت في {when}",
  "mkt.duplicate": "تكرار",
  "mkt.cancel_campaign": "إيقاف الحملة",
  "mkt.stop": "إيقاف الإرسال",
  "mkt.unschedule": "إلغاء الجدولة",
  "mkt.stop_body": "الرسائل المرسلة تبقى مرسلة، ولن تصل الحملة إلى أي شخص آخر.",
  "mkt.unschedule_body": "تعود الحملة إلى المسودات، ويمكنك جدولتها مجدداً.",
  "mkt.delete_campaign": "حذف الحملة؟",
  "mkt.delete_campaign_body": "ستُحذف الحملة ونتائجها. لا يمكن التراجع عن ذلك.",
  "mkt.review_send": "مراجعة وإرسال",
  "mkt.results": "النتائج",
  "mkt.stat.delivered": "المرسلة",
  "mkt.stat.opened": "فُتحت",
  "mkt.stat.clicked": "نُقرت",
  "mkt.stat.sales": "المبيعات",
  "mkt.stat.orders": "الطلبات: {n}",
  "mkt.stat.queued": "قيد الإرسال: {n}",
  "mkt.results_note": "ألغى الاشتراك: {unsub}. لم تُرسل: {failed} (عناوين ألغت الاشتراك أو مرتدة أو محظورة). أرقام الفتح تقريبية لأن بعض تطبيقات البريد تخفيها. يُحتسب الطلب إذا تم خلال 5 أيام من النقر.",
  "mkt.error.quota": "لم تُرسل هذه الحملة: استنفد المتجر رسائل التسويق لهذا الشهر. رقِّ خطتك أو انتظر الشهر القادم.",
  "mkt.error.no_recipients": "لم تُرسل هذه الحملة: لم يطابق الجمهور أي عميل مشترك وقت الإرسال.",
  "mkt.campaign_name": "اسم الحملة",
  "mkt.campaign_name_hint": "لا يراه غيرك، ويُستخدم أيضاً لوسم روابط الحملة (utm_campaign).",
  "mkt.language": "اللغة",
  "mkt.audience": "الجمهور",
  "mkt.audience_hint": "يشمل فقط العملاء الذين وافقوا على تلقي رسائل التسويق.",
  "mkt.send_to": "الإرسال إلى",
  "mkt.all_subscribers": "كل المشتركين",
  "mkt.exclude_recent": "استثناء المشترين مؤخراً",
  "mkt.exclude_recent_hint": "تخطَّ العملاء الذين طلبوا خلال هذه الفترة.",
  "mkt.exclude_none": "عدم استثناء أحد",
  "mkt.exclude_days": "طلبوا خلال آخر {n} يوماً",
  "mkt.audience_count": "المستلمون: {n}",
  "mkt.audience_of": "من أصل {n} مشترك",
  "mkt.quota_left": "المتبقي هذا الشهر: {n} من {limit} رسالة تسويقية",
  "mkt.send_now": "إرسال الآن",
  "mkt.schedule_later": "جدولة لوقت لاحق",
  "mkt.schedule": "جدولة",
  "mkt.send_at": "وقت الإرسال",
  "mkt.send_at_hint": "بحسب المنطقة الزمنية لجهازك.",
  "mkt.sending_now": "جارٍ الإرسال",
  "mkt.scheduled": "جُدولت الحملة",
  "mkt.compliance_note": "تحتوي كل رسالة على رابط لإلغاء الاشتراك بنقرة واحدة وعلى عنوان متجرك. تُتخطى العناوين الملغاة والمرتدة تلقائياً.",

  // email editor
  "mkt.subject": "الموضوع",
  "mkt.preheader": "نص المعاينة",
  "mkt.preheader_hint": "يظهر بعد الموضوع في معظم صناديق البريد.",
  "mkt.merge_hint": "خصّص الرسالة بـ {tags}",
  "mkt.accent": "لون الأزرار",
  "mkt.background": "الخلفية",
  "mkt.use_brand": "استخدام لون العلامة",
  "mkt.content": "المحتوى",
  "mkt.add_block": "إضافة قسم",
  "mkt.move_up": "تحريك لأعلى",
  "mkt.move_down": "تحريك لأسفل",
  "mkt.block.header": "الشعار",
  "mkt.block.heading": "عنوان",
  "mkt.block.text": "نص",
  "mkt.block.image": "صورة",
  "mkt.block.button": "زر",
  "mkt.block.products": "منتجات",
  "mkt.block.discount": "رمز خصم",
  "mkt.block.divider": "فاصل",
  "mkt.block.social": "روابط التواصل",
  "mkt.block.spacer": "مسافة",
  "mkt.block.header_hint": "شعارك من إعدادات الدفع أو اسم متجرك، مع رابط إلى المتجر.",
  "mkt.block.no_options": "لا توجد إعدادات.",
  "mkt.block.heading_default": "مرحباً {{first_name}}",
  "mkt.block.text_default": "اكتب رسالتك هنا.",
  "mkt.block.button_default": "تسوّق الآن",
  "mkt.text": "النص",
  "mkt.text_hint": "سطر فارغ يبدأ فقرة جديدة.",
  "mkt.align": "المحاذاة",
  "mkt.align.start": "البداية",
  "mkt.align.center": "الوسط",
  "mkt.button_label": "نص الزر",
  "mkt.link": "الرابط",
  "mkt.link_hint": "مسار في المتجر مثل ‎/collections/new أو رابط كامل.",
  "mkt.alt": "وصف الصورة",
  "mkt.alt_hint": "يظهر عند حظر الصور وتقرؤه برامج قراءة الشاشة.",
  "mkt.choose_image": "اختيار صورة",
  "mkt.upload": "رفع",
  "mkt.search_files": "البحث في الملفات",
  "mkt.no_files": "لا توجد صور بعد. ارفع صورة.",
  "mkt.columns": "الأعمدة",
  "mkt.products_hint": "العناوين والأسعار والصور تُؤخذ من منتجاتك عند الإرسال.",
  "mkt.code": "الرمز",
  "mkt.code_hint": "رمز من صفحة الخصومات، أو {{discount_code}} للرمز الذي أنشأته الأتمتة.",
  "mkt.social.instagram": "إنستغرام",
  "mkt.social.facebook": "فيسبوك",
  "mkt.social.x": "إكس",
  "mkt.social.tiktok": "تيك توك",
  "mkt.social.snapchat": "سناب شات",
  "mkt.social.youtube": "يوتيوب",
  "mkt.social.whatsapp": "واتساب",
  "mkt.social.linkedin": "لينكدإن",
  "mkt.social.pinterest": "بنترست",
  "mkt.preview": "المعاينة",
  "mkt.desktop": "سطح المكتب",
  "mkt.mobile": "الجوال",
  "mkt.no_subject": "(بلا موضوع)",
  "mkt.send_test": "إرسال تجريبي",
  "mkt.send": "إرسال",
  "mkt.test_to": "الإرسال إلى",
  "mkt.test_to_hint": "حتى 5 عناوين مفصولة بفواصل.",
  "mkt.test_note": "تستخدم الرسائل التجريبية بيانات عميل افتراضية ولا تُتتبع روابطها.",
  "mkt.test_sent": "الرسالة التجريبية في الطريق",
  "mkt.done": "تم",

  // automations
  "mkt.flow.create": "إنشاء أتمتة",
  "mkt.flow.untitled": "أتمتة جديدة",
  "mkt.flow.abandoned": "تذكيرات عمليات الدفع المتروكة",
  "mkt.flow.abandoned_hint": "حتى 3 تذكيرات مع رمز خصم اختياري. ميزة في المتجر لها إعداداتها الخاصة.",
  "mkt.flow.on": "مفعّلة",
  "mkt.flow.off": "متوقفة",
  "mkt.flow.settings": "الإعدادات",
  "mkt.flow.steps": "الخطوات: {n}",
  "mkt.flow.sent": "الرسائل: {n}",
  "mkt.flow.in_progress": "قيد التنفيذ: {n}",
  "mkt.flow.recipes": "ابدأ من قالب",
  "mkt.flow.recipes_hint": "أتمتة جاهزة برسائل مكتوبة لك. راجعها ثم فعّلها.",
  "mkt.flow.status.draft": "مسودة",
  "mkt.flow.status.active": "مفعّلة",
  "mkt.flow.status.paused": "متوقفة مؤقتاً",
  "mkt.flow.activated": "فُعّلت الأتمتة",
  "mkt.flow.paused": "أُوقفت الأتمتة مؤقتاً",
  "mkt.flow.delete": "حذف الأتمتة؟",
  "mkt.flow.delete_body": "يتوقف العملاء الجارية معالجتهم هنا، وتُحذف نتائجها.",
  "mkt.flow.turn_on": "تفعيل",
  "mkt.flow.runs": "العملاء الداخلون",
  "mkt.flow.name": "الاسم",
  "mkt.flow.trigger": "تبدأ عندما",
  "mkt.flow.days_without_order": "أيام بلا طلب",
  "mkt.flow.steps_title": "الخطوات",
  "mkt.flow.blocks": "الأقسام: {n}",
  "mkt.flow.subscribed_only": "للمشتركين فقط",
  "mkt.flow.discount_tag_hint": "أضف قسم رمز خصم يحتوي {{discount_code}} لعرض الرمز الذي أنشأته خطوة سابقة.",
  "mkt.trigger.customer_subscribed": "يشترك عميل في رسائل التسويق",
  "mkt.trigger.first_order": "يقدّم عميل طلبه الأول",
  "mkt.trigger.order_placed": "يقدّم عميل طلباً",
  "mkt.trigger.order_fulfilled": "يُشحن طلب",
  "mkt.trigger.win_back": "لم يطلب العميل منذ {days} يوماً",
  "mkt.trigger.birthday": "عيد ميلاد العميل",
  "mkt.trigger.customer_subscribed.short": "اشتراك عميل",
  "mkt.trigger.first_order.short": "الطلب الأول",
  "mkt.trigger.order_placed.short": "تقديم طلب",
  "mkt.trigger.order_fulfilled.short": "شحن طلب",
  "mkt.trigger.win_back.short": "انقطاع عن الطلب",
  "mkt.trigger.birthday.short": "عيد الميلاد",
  "mkt.trigger.customer_subscribed.hint": "تعمل مرة واحدة لكل عميل عند موافقته على رسائل التسويق (عند الدفع أو نموذج النشرة أو الحساب أو الاستيراد).",
  "mkt.trigger.first_order.hint": "تعمل مرة واحدة للطلب الأول للعميل.",
  "mkt.trigger.order_placed.hint": "تعمل مع كل طلب يقدّمه العميل.",
  "mkt.trigger.order_fulfilled.hint": "تعمل عند شحن الطلب.",
  "mkt.trigger.win_back.hint": "تعمل مرة لكل عميل يتجاوز هذا العدد من الأيام منذ آخر طلب.",
  "mkt.trigger.birthday.hint": "تستخدم تاريخ ميلاد العميل في الحقل facts.birth_date بصيغة YYYY-MM-DD. تعمل مرة كل عام.",
  "mkt.step.wait": "انتظار",
  "mkt.step.condition": "التحقق من شرط",
  "mkt.step.send_email": "إرسال رسالة",
  "mkt.step.add_tag": "إضافة وسم للعميل",
  "mkt.step.issue_discount": "إنشاء رمز خصم",
  "mkt.step.notify_staff": "تنبيه الفريق",
  "mkt.step.tag_placeholder": "الوسم، مثل VIP",
  "mkt.step.percent_off": "% خصم، صالح لمدة",
  "mkt.step.days_valid": "يوماً",
  "mkt.step.discount_hint": "رمز يُستخدم مرة واحدة لهذا العميل فقط. اعرضه في رسالة لاحقة بـ {{discount_code}}.",
  "mkt.step.staff_placeholder": "ما يراه الفريق، مثل: أصبح {{first_name}} من كبار العملاء",
  "mkt.cond.not_ordered_since_start": "لم يطلب منذ البداية",
  "mkt.cond.ordered_since_start": "طلب منذ البداية",
  "mkt.cond.is_subscribed": "مشترك في البريد",
  "mkt.cond.orders_count_gte": "عدد الطلبات لا يقل عن",
  "mkt.cond.total_spent_gte": "إجمالي الإنفاق لا يقل عن",
  "mkt.cond.has_tag": "لديه الوسم",
  "mkt.cond.not_has_tag": "ليس لديه الوسم",
  "mkt.cond.stop_hint": "إن لم يتحقق، تنتهي الأتمتة لهذا العميل.",
  "mkt.unit.hours": "ساعات",
  "mkt.unit.days": "أيام",
  "mkt.edit_email": "تعديل الرسالة",
  "mkt.view_email": "عرض الرسالة",

  // feeds
  "mkt.feed.add": "إضافة خلاصة",
  "mkt.feed.empty": "بِع على جوجل وإنستغرام وتيك توك وسناب شات",
  "mkt.feed.empty_body": "أنشئ خلاصة منتجات وأضف رابطها في Google Merchant Center أو كتالوج ميتا أو تيك توك أو سناب شات. تتحدث كل ساعة.",
  "mkt.feed.channel": "القناة",
  "mkt.feed.channel.google": "Google Merchant Center",
  "mkt.feed.channel.meta": "ميتا (فيسبوك وإنستغرام)",
  "mkt.feed.channel.tiktok": "تيك توك",
  "mkt.feed.channel.snapchat": "سناب شات",
  "mkt.feed.setup.google": "طريقة إضافتها في Merchant Center",
  "mkt.feed.setup.meta": "طريقة إضافتها في Commerce Manager",
  "mkt.feed.setup.tiktok": "طريقة إضافتها في كتالوج تيك توك",
  "mkt.feed.setup.snapchat": "طريقة إضافتها في كتالوج سناب شات",
  "mkt.feed.name": "الاسم",
  "mkt.feed.country": "الدولة المستهدفة",
  "mkt.feed.country_hint": "حيث ستعلن. الأسعار بعملة متجرك.",
  "mkt.feed.brand_fallback": "العلامة للمنتجات بلا مورّد",
  "mkt.feed.brand_fallback_hint": "يُستخدم اسم متجرك إن تُرك فارغاً.",
  "mkt.feed.include_oos": "تضمين المنتجات النافدة",
  "mkt.feed.items": "العناصر: {n}",
  "mkt.feed.built": "آخر جلب في {when}",
  "mkt.feed.not_fetched": "لم تُجلب بعد",
  "mkt.feed.check": "فحص المنتجات",
  "mkt.feed.edit": "تعديل",
  "mkt.feed.rotate": "رابط سري جديد",
  "mkt.feed.rotate_body": "سيتوقف الرابط الحالي عن العمل. حدّثه في القناة بعد ذلك.",
  "mkt.feed.rotated": "أُنشئ رابط جديد",
  "mkt.feed.delete": "حذف الخلاصة؟",
  "mkt.feed.delete_body": "لن تتمكن القناة من قراءة منتجاتك من هذا الرابط.",
  "mkt.feed.note": "تعرض الخلاصات المنتجات النشطة في متجرك الإلكتروني، عنصراً لكل متغير. حافظ على سرية الروابط.",
  "mkt.feed.check_title": "فحص: {name}",
  "mkt.feed.ready": "{ready} من {total} عنصر جاهزة للعرض",
  "mkt.feed.examples": "أمثلة",
  "mkt.feed.issue.missing_image": "بلا صورة (مرفوض)",
  "mkt.feed.issue.missing_price": "بلا سعر (مرفوض)",
  "mkt.feed.issue.missing_description": "بلا وصف",
  "mkt.feed.issue.missing_identifiers": "بلا باركود (GTIN) أو SKU",
  "mkt.feed.issue.missing_brand": "بلا مورّد (علامة)",
  "mkt.feed.issue.missing_category": "بلا فئة منتج",

  // SEO
  "seo.title": "تحسين محركات البحث",
  "seo.description": "ساعد محركات البحث على عرض منتجاتك بشكل أفضل.",
  "seo.tab.overview": "نظرة عامة",
  "seo.tab.bulk": "العناوين والأوصاف",
  "seo.tab.alt": "النص البديل للصور",
  "seo.tab.links": "الروابط المعطلة",
  "seo.rich": "النتائج المنسّقة للمنتجات",
  "seo.rich_hint": "المنتجات التي لها صورة وسعر ووصف يمكن أن تظهر في جوجل مع السعر والتوفر.",
  "seo.rich_count": "{n} من {total} منتج نشط مؤهلة.",
  "seo.with_reviews": "منها {n} تظهر بتقييم النجوم أيضاً.",
  "seo.checks": "ما يمكن تحسينه",
  "seo.check.missing_image": "منتجات بلا صورة",
  "seo.check.missing_description": "منتجات بلا وصف",
  "seo.check.missing_brand": "منتجات بلا مورّد (علامة)",
  "seo.check.missing_gtin": "منتجات بلا باركود (GTIN)",
  "seo.check.missing_seo_title": "منتجات بلا عنوان صفحة",
  "seo.check.missing_seo_description": "منتجات بلا وصف ميتا",
  "seo.check.images_missing_alt": "صور بلا نص بديل",
  "seo.fix": "إصلاح",
  "seo.more": "إعدادات أخرى لتحسين البحث",
  "seo.more.preferences": "التفضيلات",
  "seo.more.preferences_hint": "عنوان الصفحة الرئيسية وصورة المشاركة والتحقق في Google Search Console",
  "seo.more.feeds": "خلاصات المنتجات",
  "seo.more.feeds_hint": "قوائم مجانية في Google Shopping",
  "seo.more.sitemap": "خريطة الموقع وملف robots.txt",
  "seo.search": "البحث في المنتجات",
  "seo.filter.missing_any": "ينقصها العنوان أو الوصف",
  "seo.filter.missing_title": "ينقصها عنوان الصفحة",
  "seo.filter.missing_description": "ينقصها وصف الميتا",
  "seo.filter.all": "كل المنتجات",
  "seo.save_n": "حفظ ({n})",
  "seo.saved": "حُفظ: {n}",
  "seo.all_done": "كل المنتجات هنا لها عنوان صفحة ووصف.",
  "seo.page_title": "عنوان الصفحة",
  "seo.meta_description": "وصف الميتا",
  "seo.search_preview": "معاينة نتيجة البحث",
  "seo.no_description": "أضف وصفاً ليظهر هنا.",
  "seo.alt_title": "النص البديل للصور",
  "seo.alt_hint": "{missing} من {total} صورة منتج بلا وصف.",
  "seo.alt_done": "كل صور المنتجات لها نص بديل.",
  "seo.alt_label": "النص البديل",
  "seo.alt_placeholder": "صف صورة {product}",
  "seo.links_title": "الروابط المعطلة",
  "seo.links_hint": "روابط في القوائم والصفحات ومقالات المدونة والقالب تشير إلى صفحات غير موجودة.",
  "seo.check_links": "فحص الروابط",
  "seo.check_again": "فحص مجدداً",
  "seo.links_idle": "شغّل الفحص للعثور على روابط تؤدي إلى صفحات مفقودة.",
  "seo.links_ok": "كل الروابط تعمل ({n}).",
  "seo.links_found": "روابط معطلة: {n} من أصل {checked}.",
  "seo.source.menu": "قائمة",
  "seo.source.page": "صفحة",
  "seo.source.article": "مقال",
  "seo.source.theme": "القالب",

  // preferences: verification
  "prefs.verification": "التحقق من الموقع",
  "prefs.verification_hint": "أثبت ملكيتك للمتجر لدى Google Search Console وBing وميتا وغيرها.",
  "prefs.verify.google": "Google Search Console",
  "prefs.verify.bing": "Bing Webmaster Tools",
  "prefs.verify.meta": "ميتا (التحقق من النطاق)",
  "prefs.verify.pinterest": "بنترست",
  "prefs.verify.tiktok": "تيك توك",
  "prefs.verify.yandex": "ياندكس",
  "prefs.verify_placeholder": "الصق وسم الميتا أو قيمة المحتوى فيه",
  "prefs.verification_note": "تُضاف الوسوم إلى صفحتك الرئيسية. اختر طريقة وسم HTML في الخدمة.",

  // reports
  "an.report.abandoned_recovery": "استرداد عمليات الدفع المتروكة",
  "an.col.reminded": "تم تذكيرهم",
  "an.col.clicked": "نقروا",
  "an.col.recovery_rate": "معدل الاسترداد",
  "an.col.recovered_sales": "المبيعات المستردة",
} as const;

export default marketingAr;
